import React, { useState } from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from "recharts";
import Grid from "@mui/material/Grid2";
import { ChevronLeft, ChevronRight, Visibility } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import { getEnergyUsage } from "selectors/energyAssistance.selectors";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const EnergyAssistanceChart = () => {
  const energyUsage = useSelector(getEnergyUsage);
  const data = energyUsage?.Data?.EnergyUsageDetails_Res || [];
  const [view, setView] = useState("second");

  const sortedUsage = data.slice().sort((a, b) => {
    const dateA = dayjs(a.MonthYear);
    const dateB = dayjs(b.MonthYear);
    return dateA.isAfter(dateB) ? 1 : -1;
  });

  const maxUsage = Math.max(...data.map((d) => d.Therms));
  const totalTherm = parseFloat(
    data.reduce((sum, item) => sum + item.Therms, 0).toFixed(2)
  );

  const displayedData =
    view === "first"
      ? sortedUsage.slice(0, sortedUsage.length / 2)
      : sortedUsage.slice(sortedUsage.length / 2, sortedUsage.length);

  return (
    <Card
      className="EnergyAssistanceChart"
      sx={{ maxWidth: "100%", p: 2, borderRadius: 3, boxShadow: 3 }}
    >
      <CardContent className="EnergyAssistanceChartlist">
        <Grid container spacing={2}>
          <Grid size={{ xs: 6, sm: 6, md: 6 }}>
            <Typography color="textSecondary">LAST 12 MONTHS USAGE</Typography>
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 6 }}>
            <Typography fontWeight="bold" className="text-Right">
              <span> {totalTherm} </span>THERMS
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
      <CardContent sx={{ pt: 0 }} className="EnergyAssistanceChartlistdata">
        <ResponsiveContainer width="100%" height={150}>
          <Box
            sx={{ height: "auto" }}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <IconButton
              size="small"
              onClick={() => setView("first")}
              sx={{
                visibility: view === "first" ? "hidden" : "visible",
              }}
            >
              <ChevronLeft sx={{ color: "#07254A" }} />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => setView("second")}
              sx={{
                visibility: view === "first" ? "visible" : "hidden",
              }}
            >
              <ChevronRight sx={{ color: "#07254A" }} />
            </IconButton>
          </Box>
          <BarChart
            data={displayedData}
            barCategoryGap="65%"
            margin={{ bottom: 36 }}
          >
            <XAxis
              dataKey="MonthYear"
              interval={0}
              axisLine={false}
              tickLine={false}
              tick={({ x, y, payload }) => {
                const usage = displayedData[payload.index]?.Therms;
                return (
                  <g transform={`translate(${x},${y})`}>
                    <text
                      x={0}
                      y={-4}
                      dy={16}
                      textAnchor="middle"
                      fill="#4D4C52"
                      fontSize={12}
                    >
                      {usage}
                    </text>

                    <text
                      x={0}
                      y={16}
                      dy={16}
                      textAnchor="middle"
                      fill="#07254A"
                      fontSize={14}
                      fontWeight={700}
                    >
                      {payload.value}
                    </text>
                  </g>
                );
              }}
            />
            <YAxis domain={[0, maxUsage]} hide />
            <Bar dataKey="Therms" fill="#0052CC" />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default EnergyAssistanceChart;
